import { authRequest } from "../utils/request";
import { AxiosResponse } from "axios";

/**
 * API0040 認証者情報取得 レスポンスインターフェース
 */
export type MeResponse = {
  userName: string;
  needPasswordChange?: boolean;
  agentCode?: string;
  agentName?: string;
  affiliation?: string;
};

/**
 * API0040 認証者情報取得
 * @returns
 */
export const getMe = async (): Promise<AxiosResponse<MeResponse>> => {
  return await authRequest.get<MeResponse>("/v1/me");
};
